// タイムラインに出す項目を選ぶバッジ
//
// 通知ログ画面のドメインチップと同じ操作感。初期状態は全部表示で、
// タップした種類だけをタイムラインから外す。
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

import { TIMELINE_ITEM_FILTERS, type TimelineItemType } from '../timeline-item-filters'

type Props = {
  /** 並べる種類（ビューによって扱える項目が違うため呼び出し側が渡す） */
  types: readonly TimelineItemType[]
  hiddenTypes: ReadonlySet<TimelineItemType>
  onToggle: (type: TimelineItemType) => void
}

export const TimelineItemFilterChips = ({ types, hiddenTypes, onToggle }: Props) => {
  const filters = TIMELINE_ITEM_FILTERS.filter((filter) => types.includes(filter.value))
  if (filters.length === 0) return null

  return (
    <div className="flex gap-1.5 overflow-x-auto px-4 py-1">
      {filters.map((filter) => {
        const Icon = filter.icon
        const isVisible = !hiddenTypes.has(filter.value)
        return (
          <button
            key={filter.value}
            type="button"
            aria-pressed={isVisible}
            onClick={() => onToggle(filter.value)}
            className="shrink-0"
          >
            <Badge
              variant="outline"
              className={cn('cursor-pointer gap-1 text-xs', filter.color, !isVisible && 'opacity-30')}
            >
              <Icon className="size-3" />
              {filter.label}
            </Badge>
          </button>
        )
      })}
    </div>
  )
}
